import React, { useEffect, useState } from 'react';
import { Layout, Menu, Avatar, Button, Modal } from 'antd';
import { UserOutlined, LogoutOutlined, ClusterOutlined, TagsOutlined, TranslationOutlined, ProjectOutlined, FileSyncOutlined } from '@ant-design/icons';
import './App.css';
// @ts-ignore
import logo from './logo.svg';
import CommentsClustering from './components/CommentsClustering';
import TextLabelRecognition from './components/TextLabelRecognition';
import TextTranslation from './components/TextTranslation';
import CustomProject from './components/CustomProject';
import PlatformTypeConversion from './components/PlatformTypeConversion';

const { Header, Sider, Content, Footer } = Layout;


function getTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get('access_token');
}

function removeTokenFromUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('access_token');
  window.history.replaceState({}, document.title, url.pathname + url.search);
}

function getTokenFromStorage() {
  return localStorage.getItem('access_token') || '';
}

function saveTokenToStorage(token: string) {
  localStorage.setItem('access_token', token);
}



function App() {
  const [selectedMenu, setSelectedMenu] = useState('评论观点聚类');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [token, setToken] = useState('');
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [authLoading, setAuthLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  // 应用状态
  const [currentMenu, setCurrentMenu] = useState('comments_clustering');
  const [isAdmin, setIsAdmin] = useState(false);



  // 校验token逻辑
  useEffect(() => {
    async function validateToken(token: string) {
      try {
        const res = await fetch('/login/api/validate_token', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await res.json();
        if (data.valid) {
          setToken(token);
          setUsername(data.user_id || '');
          setDisplayName(data.name || data.user_id || '');
          setIsLoggedIn(true);
          saveTokenToStorage(token);
          setAuthLoading(false);
        } else {
          setToken('');
          setUsername('');
          setDisplayName('');
          setIsLoggedIn(false);
          localStorage.removeItem('access_token');
          setAuthLoading(false);
          Modal.error({
            title: '登录已失效',
            content: '请重新登录',
            onOk: () => {
              window.location.href = 'https://login.sysjdata.com/login?redirect_uri=https://auto.sysjdata.com';
            }
          });
          return;
        }
      } catch {
        setToken('');
        setUsername('');
        setDisplayName('');
        setIsLoggedIn(false);
        setAuthLoading(false);
      }
    }
    const urlToken = getTokenFromUrl();
    if (urlToken) {
      validateToken(urlToken);
      removeTokenFromUrl();
    } else {
      const storageToken = getTokenFromStorage();
      if (storageToken) {
        validateToken(storageToken);
      } else {
        setIsLoggedIn(false);
        setAuthLoading(false);
        Modal.error({
          title: '未登录',
          content: '请先登录',
          onOk: () => {
            window.location.href = 'https://login.sysjdata.com/login?redirect_uri=https://auto.sysjdata.com';
          }
        });
      }
    }
  }, []);

  // 检查是否为管理员
  useEffect(() => {
    const adminUsers = ['workwechat_TangTou', 'superuser0'];
    setIsAdmin(adminUsers.includes(username));
  }, [username]);





  const handleLogout = () => {
    localStorage.removeItem('access_token');
    setToken('');
    setUsername('');
    setDisplayName('');
    setIsLoggedIn(false);
    Modal.success({
      title: '已退出登录',
      content: '即将跳转到登录页面',
      onOk: () => {
        window.location.href = 'https://login.sysjdata.com/login?redirect_uri=https://auto.sysjdata.com';
      }
    });
  };















  // 渲染内容区域
  const renderContent = () => {
    if (!isLoggedIn) {
      return (
        <div style={{ textAlign: 'center', padding: '50px 0' }}>
          <div>请先登录</div>
        </div>
      );
    }
    
    if (currentMenu === 'comments_clustering') {
      return (
        <CommentsClustering username={username} isLoggedIn={isLoggedIn} />
      );
    } else if (currentMenu === 'text_label') {
      return <TextLabelRecognition username={username} isAdmin={isAdmin} isLoggedIn={isLoggedIn} />;
    } else if (currentMenu === 'text_translation') {
      return <TextTranslation username={username} isLoggedIn={isLoggedIn} />;
    } else if (currentMenu === 'custom_project') {
      return <CustomProject username={username} displayName={displayName} isLoggedIn={isLoggedIn} />;
    } else if (currentMenu === 'platform_type_conversion') {
      return <PlatformTypeConversion username={username} isLoggedIn={isLoggedIn} />;
    }
    return null;
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={220} style={{ background: '#17375e' }}>
        <div className="logo-area">
          <img src={logo} alt="logo" className="logo-img" />
          <div className="logo-title">SY-AI自动化系统</div>
        </div>
        <div className="user-area">
          <Avatar size={48} icon={<UserOutlined />} />
          <div className="user-name">欢迎你，<span className="username-highlight">{displayName || username || '未登录'}</span></div>
          <Button icon={<LogoutOutlined />} size="small" className="logout-btn" onClick={handleLogout}>退出</Button>
        </div>
        <Menu 
          theme="dark" 
          mode="inline" 
          selectedKeys={[currentMenu]} 
          style={{ background: '#17375e', marginTop: 24 }}
          onClick={({ key }) => {
            setCurrentMenu(key);
            if (key === 'comments_clustering') {
              setSelectedMenu('评论观点聚类');
            } else if (key === 'text_label') {
              setSelectedMenu('文本标签识别');
            } else if (key === 'text_translation') {
              setSelectedMenu('文本智能翻译');
            } else if (key === 'custom_project') {
              setSelectedMenu('项目个性定制');
            } else if (key === 'platform_type_conversion') {
              setSelectedMenu('平台类型转换');
            }
          }}
          items={[
            {
              key: 'comments_clustering',
              icon: <ClusterOutlined />,
              label: '评论观点聚类'
            },
            {
              key: 'text_label',
              icon: <TagsOutlined />,
              label: '文本标签识别'
            },
            {
              key: 'text_translation',
              icon: <TranslationOutlined />,
              label: '文本智能翻译'
            },
            {
              key: 'custom_project',
              icon: <ProjectOutlined />,
              label: '项目个性定制'
            },
            {
              key: 'platform_type_conversion',
              icon: <FileSyncOutlined />,
              label: '平台类型转换'
            }
          ]}
        />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', fontSize: 20, fontWeight: 500, borderBottom: '1px solid #f0f0f0' }}>
          {selectedMenu}
        </Header>
        <Content style={{ margin: 24, background: '#fff', padding: 24, borderRadius: 8 }}>
          {renderContent()}
          





        </Content>
        <Footer style={{ textAlign: 'center', background: '#f5f7fa', fontSize: 13, padding: '16px 0' }}>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            Copyright © SYSJDATA 浙ICP备2025170290号
          </a>
        </Footer>
      </Layout>
    </Layout>
  );
}

export default App;
